import qs from 'qs'
import { AppStore } from 'src/client/store'
import { getLabPreview } from 'api/lab'
import { SET_LAB_FEATURE_FLAGS } from 'actions/actionConstants'

/**
 * Initialises the site take over based on the search query found
 */
function intialiseSiteTakeover(store: AppStore) {
  const searchParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  if (typeof searchParams.labPreviewId === 'string') {
    const labPreviewId = searchParams.labPreviewId
    getLabPreview(labPreviewId).then(labFlags => {
      store.dispatch({
        type: SET_LAB_FEATURE_FLAGS,
        labFlags,
      })
    }).catch(error => {
      console.error(JSON.stringify(error))
    })
  }
}

export default intialiseSiteTakeover
